export default __webpack_public_path__ + "static/media/location.3c9935b1.svg";